import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePut from "../put/usePut";
import useGet from "../read/useGet";
import toast from "react-hot-toast";
import { checkIfNotEmpty } from "../../utility";
import { debounce } from "lodash";

const useLeaveStructureSettings = ({ companyId }) => {
  const navigate = useNavigate();
  // Getting the leave structure
  const { list, setGetListParams } = useGet({
    url: "settings/leave/list",
    initialData: {
      company_id: companyId,
    },
  });
  const leavesData = list?.data;
  const isLoading = list.isLoading;

  // Create & update leave type
  const { handleAuth: createUpdateReq } = usePut({
    url: "settings/leave/create",
    refreshUrl: ["settings/leave/list", "dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: () => {
      if (checkIfNotEmpty(editData)) {
        toast.success("Leave type updated successfully");
      } else {
        toast.success("Leave type added successfully");
      }
      closeAddModal();
      closeEditModal();
      if (sessionStorage.getItem("onboarding_flow") === "true") {
        sessionStorage.removeItem("onboarding_flow");
        // navigate("/onboarding");
      }
    },
  });

  const [searchQuery, setSearchQuery] = useState("");

  const debouncedSearch = useRef(
    debounce((search) => {
      setGetListParams((prev) => {
        return { ...prev, search_query: search };
      });
    }, 700)
  ).current;

  const searchLeaveType = (search) => {
    setSearchQuery(search);
    debouncedSearch(search);
  };

  const handlePageClick = (val) => {
    setGetListParams((prev) => {
      return { ...prev, page_number: val.selected };
    });
  };

  const handleCreateLeaveType = (data) => {
    createUpdateReq.mutate(data);
  };

  const handleUpdateLeaveType = (data) => {
    createUpdateReq.mutate(data);
  };

  // Delete leave type
  const { handleAuth: deleteReq } = usePut({
    url: "settings/leave/delete",
    refreshUrl: ["settings/leave/list", "dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: () => {
      toast.success("Salary type deleted successfully");
    },
  });

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [deleteData, setDeleteData] = useState(null);

  const openDeleteConfirmation = (data) => {
    setDeleteData(data);
    setShowDeleteConfirmation(true);
  };

  const closeDeleteConfirmation = () => {
    setShowDeleteConfirmation(false);
  };

  const handleDeleteType = () => {
    deleteReq.mutate(deleteData);
    setShowDeleteConfirmation(false);
  };

  // Addition Modal
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  // Edit Modal
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({});

  const openEditModal = (data) => {
    setEditData(data);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditData(null);
  };

  return {
    handleCreateLeaveType,
    handleUpdateLeaveType,
    openAddModal,
    closeAddModal,
    openEditModal,
    closeEditModal,
    searchLeaveType,
    handlePageClick,
    openDeleteConfirmation,
    closeDeleteConfirmation,
    handleDeleteType,
    showDeleteConfirmation,
    leavesData,
    isAddModalOpen,
    isEditModalOpen,
    editData,
    isLoading,
  };
};

export default useLeaveStructureSettings;
